// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__BNSwV","modalForm":"UpgradeEpcsModal_modalForm__2Vgta","modalFooter":"UpgradeEpcsModal_modalFooter__3tB4U"};